/**
 * 地図タイプ（地図 / 航空写真）の切替コントロール
 *
 * Dynamic Maps SKU 内の機能なので、切り替えても課金は増えない。
 */

import { ControlPosition, MapControl } from '@vis.gl/react-google-maps'
import { Layers, Map as MapIcon } from 'lucide-react'

import type { MapTypeId } from './use-map-type'

type MapTypeControlProps = {
  value: MapTypeId
  onChange: (value: MapTypeId) => void
  position?: ControlPosition
}

export function MapTypeControl({ value, onChange, position = ControlPosition.TOP_LEFT }: MapTypeControlProps) {
  const isSatellite = value === 'hybrid'
  const label = isSatellite ? '地図' : '航空写真'
  const Icon = isSatellite ? MapIcon : Layers

  return (
    <MapControl position={position}>
      <button
        type="button"
        aria-label={`${label}に切り替え`}
        onClick={() => onChange(isSatellite ? 'roadmap' : 'hybrid')}
        className="m-2 flex items-center gap-1 rounded-md bg-white px-2.5 py-1.5 text-xs font-medium text-gray-700 shadow-md hover:bg-gray-50"
      >
        <Icon className="size-4" />
        {label}
      </button>
    </MapControl>
  )
}
